import SuccessColoredOutlinedSVG from './icon_success_colored_outlined.svg';
import withIconProps from './withIconProps';

export default withIconProps(SuccessColoredOutlinedSVG);
